export default {
    numberFormat: function (value) {
        if (!value) return '';
        value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        return value;
    },
    ceil: function (value) {
        if (!value) return '';
        value = Math.ceil(value);
        return value;
    },

}